import { getContentTypeFromExtension } from "../../utils/formatters/FileFormatter";
import { DocumentPanelItem } from "./types";

export const getDocumentContentType = (document: DocumentPanelItem) => {
    const rawData = document.data ?? "";
    if (rawData.startsWith("data:")) {
        const match = rawData.match(/^data:([^;]+);/);
        if (match?.[1]) return match[1];
    }

    return document.contentType ??
        getContentTypeFromExtension(document.contentType) ??
        getContentTypeFromExtension(document.fileName?.split(".").pop());
};

export const getDocumentCacheKeys = (document: DocumentPanelItem) =>
    [document.documentKey ?? "", document.fileName ?? "", String(document.id ?? "")].filter(Boolean);

export const getDocumentListKey = (document: DocumentPanelItem) =>
    document.documentKey ?? document.id ?? document.fileName;
